import { QuantitySelectorUI } from "./QuantitySelectorUI";
import { StandardProps } from "../componentMap";
import { ensureIsActiveVariant } from "../../utils/product/ensureIsActive";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { ADD_TO_BASKET_ESI_QUANTITY_UPDATED } from "@/constants/constants.ts";
import { useEffect } from "react";

export function QuantitySelector({
  product,
  flags,
}: Pick<StandardProps, "product" | "flags">) {
  const { variant, isSelected } = useVariant(product);

  const activeVariant = ensureIsActiveVariant(variant);
  const isShipFromStore = activeVariant?.availability?.shipFromStore;

  const showQuantitySelector = flags.showQuantitySelector?.value ?? true;
  useEffect(() => {
    if (isShipFromStore) {
      const event = new CustomEvent(ADD_TO_BASKET_ESI_QUANTITY_UPDATED, {
        detail: {
          quantity: 1,
        },
      });
      window.dispatchEvent(event);
    }
  }, [isShipFromStore]);

  if (!activeVariant) return null;

  const { availableToOrder, shipFromStore } = activeVariant.availability;

  const shouldNotDisplay =
    !availableToOrder || shipFromStore || !showQuantitySelector;

  if (shouldNotDisplay) return null;

  return <QuantitySelectorUI disabled={!isSelected} />;
}
